import * as Monitaro from '@/infrastructure/network/Monitaro/schema/models'
import { APIRequest } from '@/infrastructure/network/APIRequest'
import { HTTPMethod } from '@/infrastructure/network/types'

/**
 * レポートデータの取得
 *
 * 指定された期間のレポートデータを取得する
 */
export class GetReport implements APIRequest<Monitaro.GetReportResponse> {
  response: Monitaro.GetReportResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  params?: Monitaro.ReportRequest
  constructor(params?: Monitaro.ReportRequest) {
    this.params = params
    this.path = `/reports`
  }
}

/**
 * レポートのランキングデータを取得する
 *
 * 指定されたタイプのラインキングデータを返す
 */
export class FetchRanking implements APIRequest<Monitaro.FetchRankingResponse> {
  response: Monitaro.FetchRankingResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  params?: Monitaro.Query
  constructor(type: string, query?: Monitaro.Query) {
    this.params = query
    this.path = `/reports/${type}`
  }
}
